export interface SelectedTime {
  hours: number;
  minutes: number;
}

export enum TimePickerEvents {
  CHANGE = 'change',
}
